import type { DataValue, JSONDataValue } from '@/api/activities'

export const parseActivityOptions = (data: string): DataValue => {
  try {
    const resp = JSON.parse(data) as JSONDataValue

    const result: DataValue = {
      canReturn: resp.CanReturn,
      canSelectNotInMyPossession: resp.CanSelectNotInMyPoseesion,
      eComPolicyIds: resp.eComPolicyIds,
      options: resp.Options.map(option => ({
        optionId: option.OptionId,
        numberOfMonths: option.NumberOfMonths,
      })),
    }

    return result
  } catch (error) {
    throw new Error('Error parsing activity options')
  }
}
